import { render, staticRenderFns } from "./batchOrderList.vue?vue&type=template&id=75fa1f87"
import script from "./batchOrderList.vue?vue&type=script&lang=js"
export * from "./batchOrderList.vue?vue&type=script&lang=js"
import style0 from "./batchOrderList.vue?vue&type=style&index=0&id=75fa1f87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports